import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Checkbox, Input, Modal, Select, Spin, Tooltip } from 'antd'
import commissions from '@services/commissions'
import { alertPopup } from '@utils/popup'
import MathExpr, { op } from '../MathExpr'
import SubscriptionOptionLabel from '../SubscriptionOptionLabel'
import { COMMISSION_SELECT_STYLES } from '../commissionSelectStyles'

@inject(({ popupStore, mentorCommissionStore }) => ({ popupStore, mentorCommissionStore }))
@observer
export default class MentorCreditCommission extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSubmit: false,
            loadingData: false,
            noEligibleSub: false,

            oneTimeCommission: false,
            mentorCommissions: null,
            selectedSubscription: {},
            subscriptionsToDisplay: [],
            monthRange: [],
            months: 0,
            oneTimeAmount: null,
            year: null,
            month: null,
            comment: ''
        }
    }

    componentDidMount() {
        this.getMentorCommissions()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.mentorCommissions && this.state.mentorCommissions) {
            this.setSubscriptionList()
        }

        if (prevState.selectedSubscription.id != this.state.selectedSubscription.id) {
            this.onSubscriptionSelect()
        }
    }

    getMentorCommissions = () => {
        this.setState({ loadingData: true }, () => {
            const {
                popupStore: {
                    info: {
                        clientAgentInfo: {
                            selectedClient: { client_id }
                        },
                        agentInfo: { id: agent_id, mentor_id }
                    }
                }
            } = this.props

            commissions
                .getMentorCommissionsByAgentClient({ mentor_id, agent_id, client_id })
                .then(res => {
                    this.setState({ mentorCommissions: res.data })
                })
                .catch(() => {})
                .finally(() => this.setState({ loadingData: false }))
        })
    }

    setSubscriptionList = () => {
        const {
            clientAgentInfo: { recentClientSubscriptions }
        } = this.props.popupStore.info
        let subscriptionsToDisplay = []

        recentClientSubscriptions.forEach(sub => {
            if (!this.subscriptionHasCommission(sub.user_subscription_id)) subscriptionsToDisplay.push(sub)
            // else this.setState({ noEligibleSub: true })
        })

        if (subscriptionsToDisplay.length === 0) {
            this.setState({ noEligibleSub: true })
        }

        if (subscriptionsToDisplay.length) {
            this.setState({
                subscriptionsToDisplay,
                selectedSubscription: subscriptionsToDisplay[0]
            })
        }
    }

    subscriptionHasCommission = userSubId => {
        const { mentorCommissions } = this.state
        let found = false
        mentorCommissions.forEach(({ user_subscription_id, user_special_subscription_id, status, balance }) => {
            if (balance == 'CREDIT' && status == 'ACTIVE') {
                if ([user_special_subscription_id + '', user_subscription_id + ''].includes(userSubId + '')) {
                    found = true
                }
            }
        })
        return found
    }

    selectSubscription = id => {
        const { subscriptionsToDisplay } = this.state

        let selectedSubscription = subscriptionsToDisplay.find(({ select_id }) => select_id == id)

        this.setState({ selectedSubscription })
    }

    onSubscriptionSelect = () => {
        const {
            info: { agentInfo }
        } = this.props.popupStore
        const { selectedSubscription } = this.state
        let monthRange = [],
            months = 0,
            month,
            year

        let paidAt = new Date(selectedSubscription.paid_at)
        month = paidAt.getMonth() + 1
        year = paidAt.getFullYear() - 2000

        if (selectedSubscription.subscription_status == 'CANCELED') {
            monthRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

            let cur = new Date()
            months = (cur.getFullYear() - paidAt.getFullYear()) * 12
            months -= paidAt.getMonth()
            months += cur.getMonth()
            months = months <= 0 ? 0 : months
        } else {
            if (selectedSubscription.product_name == 'Mediwho Fly' || agentInfo.monthly_commission) {
                monthRange = [1]
                months = 1
            } else {
                monthRange = [12]
                months = 12
            }
        }

        this.setState({ monthRange, months, month, year })
    }

    toggleOneTime = () => {
        const { oneTimeCommission } = this.state

        if (!oneTimeCommission) {
            this.setState({
                oneTimeCommission: true,
                year: new Date().getFullYear() - 2000,
                month: new Date().getMonth() + 1
            })
        } else {
            this.setSubscriptionList()
            this.setState({ oneTimeCommission: false, selectedSubscription: {} })
        }
    }

    onAmountInput = ({ target: { value } }) => {
        value = value.replace(/\D/, '')
        this.setState({ oneTimeAmount: value })
    }

    onTextInput = ({ target: { value } }) => {
        this.setState({ comment: value })
    }

    valid = () => {
        const { oneTimeCommission, comment, oneTimeAmount } = this.state
        return oneTimeCommission ? Number(oneTimeAmount) > 0 && comment && comment.length >= 4 : true
    }

    onClose = () => {
        this.props.popupStore.togglePopup(false)
    }

    submit = () => {
        const {
            info: {
                clientAgentInfo,
                clientAgentInfo: {
                    selectedClient: { client_id }
                },
                agentInfo: { id: agent_id, mentor_id, mentor_percent }
            }
        } = this.props.popupStore

        const { mentorCommissionStore } = this.props

        const { oneTimeCommission, selectedSubscription, months, month, year, oneTimeAmount, comment } = this.state

        if (!this.valid()) return

        let agentClientCommissions
        let agentCommission
        if (clientAgentInfo.clientCommissions && clientAgentInfo.clientCommissions.commissions) {
            agentClientCommissions = clientAgentInfo.clientCommissions.commissions
            agentCommission = agentClientCommissions.find(
                ({ user_subscription_id, balance }) =>
                    balance === 'CREDIT' && user_subscription_id == selectedSubscription.user_subscription_id
            ) // specialSub ?
        } // else

        const payload = {
            mentor_id,
            amount: oneTimeCommission
                ? oneTimeAmount
                : selectedSubscription.subscription_status == 'CANCELED'
                ? selectedSubscription.price * months
                : selectedSubscription.price,
            payment_type:
                selectedSubscription.specialSub || selectedSubscription.subscription_status == 'CANCELED'
                    ? 'ONE_TIME'
                    : oneTimeCommission
                    ? 'GENERAL_ONE_TIME'
                    : 'YEARLY',
            month,
            year,
            user_subscription_id: selectedSubscription.specialSub ? null : selectedSubscription.user_subscription_id,
            user_special_subscription_id: selectedSubscription.specialSub
                ? selectedSubscription.user_subscription_id
                : null,
            agent_commission_id: agentCommission ? agentCommission.id : null,
            percent: oneTimeCommission ? null : mentor_percent,
            balance: 'CREDIT',
            status: 'ACTIVE',

            months_to_charge: null,
            comment: oneTimeCommission ? comment : ''
        }

        this.setState({ loadingSubmit: true }, () => {
            commissions
                .createMentorCommission(payload)
                .then(res => {
                    // console.log('res', res.data);
                    // this.setState({ loadingSubmit: false })
                    mentorCommissionStore.getMentorCommissions({ agent_id, mentor_id, client_id })
                    alertPopup({ type: 'success', title: 'עמלת מנטור נוצרה בהצלחה', body: '' })
                })
                .catch(error => {
                    console.log('error. create mentor commission', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
        })
    }

    render() {
        const {
            loadingData,
            loadingSubmit,
            noEligibleSub,

            oneTimeCommission,
            selectedSubscription,
            monthRange,
            months,
            oneTimeAmount,
            month,
            year,
            comment
        } = this.state

        let {
            popupStore: {
                info: { agentInfo, clientAgentInfo }
            }
        } = this.props

        let selectedClient = {}
        let recentClientSubscriptions = []

        if (clientAgentInfo) {
            selectedClient = clientAgentInfo.selectedClient
            recentClientSubscriptions = clientAgentInfo.recentClientSubscriptions
        }

        // bring all client's subscriptions. including canceled.
        // deropdown
        // if canceld chosen, commission is onetime- let user calculate whole amount.
        // dropdown of months 1-12, show calculated.
        // create commission with amount = amount * months (no percent)

        // if active && no existing credit commission
        // defult by agent.monthly_commission or if fly --> 1

        /*
            title
            mentor
            select susbscription ? select client ?
            existing agent commission ?

            amount
            months
            calculated

            submit

        */

        return loadingData ? (
            <Spin />
        ) : agentInfo ? (
            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'mentorCreditCommission'}
                title={`עמלת זכות למנטור: ${agentInfo.mentor}`}
                footer={null}
                width="720px"
            >
                <style>{COMMISSION_SELECT_STYLES}</style>
                <div style={{ ...style.column, paddingInline: '30px', margin: '0 0 15px 0' }}>
                    {/* <div style={{ display: 'flex', alignSelf: 'end' }}>
                        <div style={{ ...style.box, ...style.rightBox }}>
                            <Checkbox checked={oneTimeCommission} value={oneTimeCommission} onChange={this.toggleOneTime}/>
                        </div>
                        <div style={{ ...style.box, ...style.leftBox }}>{"עמלה כללית"}</div>
                    </div> */}

                    <div style={{ ...style.formLine }}>
                        <span>{'שם הסוכן:'}</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span>{`${agentInfo.first_name} ${agentInfo.last_name}`}</span>
                        </div>
                    </div>

                    <div style={{ ...style.formLine }}>
                        <span>{'הלקוח:'}</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span>{`${selectedClient.client_first_name} ${selectedClient.client_last_name}`}</span>
                        </div>
                    </div>

                    {noEligibleSub && !oneTimeCommission ? (
                        <span>{'אין ללקוח מינויים ללא עמלת מנטור'}</span>
                    ) : (
                        <div style={{ ...style.column }}>
                            {oneTimeCommission ? (
                                ''
                            ) : (
                                <div style={{ ...style.formLine }}>
                                    <span>{'המינוי:'}</span>
                                    <div style={{ width: '70%', display: 'flex' }}>
                                        <Select
                                            className="commission-select"
                                            dropdownClassName="commission-dropdown"
                                            value={(selectedSubscription || {}).select_id}
                                            onChange={this.selectSubscription}
                                            style={{ width: '100%' }}
                                            dropdownMatchSelectWidth={false}
                                        >
                                            {recentClientSubscriptions.map((sub, idx) => {
                                                return (
                                                    <Select.Option
                                                        value={sub.select_id}
                                                        style={{ paddingInline: '8px' }}
                                                        title={sub.name}
                                                        key={idx.toString()}
                                                    >
                                                        <SubscriptionOptionLabel
                                                            name={sub.name}
                                                            subscription_status={sub.subscription_status}
                                                            paid_at={sub.paid_at}
                                                        />
                                                    </Select.Option>
                                                )
                                            })}
                                        </Select>
                                    </div>
                                </div>
                            )}
                            {oneTimeCommission ? (
                                ''
                            ) : (
                                <div style={{ ...style.formLine }}>
                                    <span>{'מחיר:'}</span>
                                    <div style={{ width: '70%', display: 'flex' }}>
                                        <span>{selectedSubscription.price}</span>
                                    </div>
                                </div>
                            )}
                            {oneTimeCommission ? (
                                ''
                            ) : (
                                <div style={{ ...style.formLine }}>
                                    <span>{'חודשים:'}</span>
                                    <div style={{ width: '70%', display: 'flex' }}>
                                        <Select
                                            className="commission-select"
                                            dropdownClassName="commission-dropdown"
                                            onChange={m => this.setState({ months: m })}
                                            value={months}
                                            style={{ width: '100%' }}
                                        >
                                            {monthRange.map(num => (
                                                <Select.Option
                                                    value={num}
                                                    style={{ paddingInline: '0' }}
                                                    title={''}
                                                    key={num.toString()}
                                                >
                                                    {num}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            )}

                            <div style={{ ...style.formLine }}>
                                <span>{'עמלת מנטור:'}</span>
                                <div style={{ width: '70%', display: 'flex' }}>
                                    {oneTimeCommission ? (
                                        <Input value={oneTimeAmount} onChange={this.onAmountInput} />
                                    ) : (
                                        <Tooltip
                                            title={
                                                <MathExpr
                                                    tokens={[
                                                        { value: selectedSubscription.price },
                                                        op('×'),
                                                        { value: agentInfo.mentor_percent },
                                                        op('×'),
                                                        { value: months }
                                                    ]}
                                                />
                                            }
                                        >
                                            <span>
                                                {`${(selectedSubscription.price * agentInfo.mentor_percent * months)
                                                    .toFixed(2)
                                                    .replace(/[^0-9.]*((\d*\.?\d{0,9})).*/g, '$2')}`}
                                            </span>
                                        </Tooltip>
                                    )}
                                </div>
                            </div>

                            <div style={{ ...style.formLine }}>
                                <span>{'שנה:'}</span>
                                <div style={{ width: '70%', display: 'flex' }}>
                                    <Select
                                        className="commission-select"
                                        dropdownClassName="commission-dropdown"
                                        value={year}
                                        onChange={year => this.setState({ year })}
                                        style={{ width: '85px' }}
                                    >
                                        {Array.from({ length: 15 }, (_, i) => 17 + i).map(num => {
                                            return (
                                                <Select.Option
                                                    value={num}
                                                    style={{ paddingInline: '0' }}
                                                    key={num.toString()}
                                                >
                                                    {num + 2000}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            </div>

                            <div style={{ ...style.formLine }}>
                                <span>{'חודש:'}</span>
                                <div style={{ width: '70%', display: 'flex' }}>
                                    <Select
                                        className="commission-select"
                                        dropdownClassName="commission-dropdown"
                                        value={month}
                                        onChange={month => this.setState({ month })}
                                        style={{ width: '85px' }}
                                    >
                                        {new Array(12).fill(null).map((_, num) => {
                                            return (
                                                <Select.Option
                                                    value={num + 1}
                                                    style={{ paddingInline: '0' }}
                                                    key={num.toString()}
                                                >
                                                    {num + 1}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                            </div>

                            {oneTimeCommission ? (
                                <div style={{ ...style.formLine }}>
                                    <span>{'פירוט:'}</span>
                                    <div style={{ width: '70%', display: 'flex' }}>
                                        <Input.TextArea value={comment} onChange={this.onTextInput} />
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}

                            <Button
                                disabled={loadingSubmit || !this.valid()}
                                onClick={this.submit}
                                style={{ alignSelf: 'center' }}
                            >
                                {loadingSubmit ? <Spin /> : 'שמירה'}
                            </Button>
                        </div>
                    )}
                </div>
            </Modal>
        ) : (
            ''
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '32px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}
